import MyAccountState from '../types/MyAccountState'

export const state: MyAccountState = {
  current: 1,
  perPage: '25'
}

